<template>
  <div>

    <div class="header">
      <!-- <custom-header></custom-header> -->
      <new-header></new-header>
    </div>
    <div class="layout-inner">
      <div class="side">
        <side-menu></side-menu>
      </div>
      <div class="main">
        <div class="content">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomHeader from './CustomHeader'
import NewHeader from './NewHeader.vue'
import SideMenu from './SideMenu'

import user from '../api/user'

export default {
  name: 'basicLayout',
  components: {
    // CustomHeader,
    NewHeader,
    SideMenu,
  },
  data() {
    return {
    }
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

$sideWidth: 100px;

.layout-inner {
  font-size: 0px;
  font-family: 600;
  overflow: hidden;
  display: flex;
  background: $bg-color;
}

.side {
  flex: none;
  vertical-align: top;
  display: inline-block;
}

.main {
  flex: 1;
  // overflow-x: auto;
}

.content {
  width: 100%;
  font-size: 16px;
  display: inline-block;
  height: calc(100vh - 68px);
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
